module.exports = __webpack_public_path__ + "img/shopIcon5.82955851.png";